import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment } from "react";
import { useTexts } from "./texts.js";
import { Kbd } from "./ui.js";
/** True on macOS (the modifier key is ⌘ there). */
export const isMac = () => typeof navigator !== "undefined" && navigator.platform.toLowerCase().includes("mac");
/** Label of the modifier key for shortcuts: "⌘" on macOS, otherwise "Strg" (texts.keyCtrl). */
export function useModKey() {
    const t = useTexts();
    return isMac() ? "⌘" : t.keyCtrl;
}
/** A text in which [x] is shown as a key: "Mit [→] und [←] blätterst du, [Esc] beendet." */
export function KeyText({ text }) {
    const parts = text.split(/\[([^\]]+)\]/g);
    return (_jsx(_Fragment, { children: parts.map((p, i) => (i % 2 ? _jsx(Kbd, { children: p }, i) : _jsx(Fragment, { children: p }, i))) }));
}
